/** TabBar registration: parser. Render registration lives in `index.r3f.ts`. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTabBar } from './parser';
const tabBarRegistration = {
    typeName: 'TabBar',
    parser: parseTabBar,
};
nodeRegistry.register(tabBarRegistration);
//# sourceMappingURL=index.js.map